import { render, staticRenderFns } from "./booksRead_v2.vue?vue&type=template&id=1722e707&scoped=true&"
import script from "./booksRead_v2.vue?vue&type=script&lang=js&"
export * from "./booksRead_v2.vue?vue&type=script&lang=js&"
import style0 from "./booksRead_v2.vue?vue&type=style&index=0&id=1722e707&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1722e707",
  null
  
)

export default component.exports